import React from "react";

import FullScreen from "~/components/Icons/svg/fullScreen";
import { ChartBarIvideon } from "~/components/Chart";
import { dataContentInfoCardCar } from "~/pages/IvideonDealerSummary2/options";

import { dataBarIProps, LabelsType } from ".";

import styles from "~/pages/IvideonDealerSummary2/IvideonDealerSummary.less";

interface ChartsCarIProps {
  dataBar: dataBarIProps;
  labels: LabelsType;
  isLoading: boolean;
  handleVariant: (prop: string) => void;
}

const ChartsCar = ({
  dataBar,
  labels,
  isLoading,
  handleVariant,
}: ChartsCarIProps) => {
  return (
    <>
      {dataContentInfoCardCar.map((item, index) => {
        return (
          <div className={styles.cardGraphSmall} key={index}>
            <div className={styles.cardTitleWrapper}>
              <span className={styles.cardTitle}>
                {dataContentInfoCardCar[index].title}
              </span>
              <div className={styles.itemTitleWrapper}>
                {index ? (
                  <>
                    <div className={styles.itemTitle}>
                      <div className={styles.colorItemOrange}></div>
                      <span>{dataContentInfoCardCar[0].label}</span>
                    </div>
                    <div className={styles.itemTitle}>
                      <div className={styles.colorItemGray}></div>
                      <span>{dataContentInfoCardCar[index].label}</span>
                    </div>
                  </>
                ) : null}
                <div
                  className={styles.wrappIcon}
                  onClick={() => handleVariant(JSON.stringify(item))}
                >
                  <FullScreen />
                </div>
              </div>
            </div>
            <ChartBarIvideon
              chartContainer={styles.chartContainer}
              data={
                index === 0
                  ? [dataBar[item.value as keyof dataBarIProps]]
                  : [
                      dataBar[
                        dataContentInfoCardCar[0].value as keyof dataBarIProps
                      ],
                      dataBar[item.value as keyof dataBarIProps],
                    ]
              }
              label={labels}
              isLoading={isLoading}
              size={{ width: "490px", height: "300px" }}
              dataContentInfoCardCar={[
                dataContentInfoCardCar[0],
                dataContentInfoCardCar[index],
              ]}
            />
          </div>
        );
      })}
    </>
  );
};

export default ChartsCar;
